export let ErrorTypes = /*#__PURE__*/function (ErrorTypes) {
  ErrorTypes["BOOKING_NOT_INSTALL"] = "BOOKING_NOT_INSTALL";
  ErrorTypes["NO_AVAILABILITY_DATES_FOUND"] = "NO_AVAILABILITY_DATES_FOUND";
  ErrorTypes["GENERAL"] = "GENERAL";
  return ErrorTypes;
}({});
export let DataStatus = /*#__PURE__*/function (DataStatus) {
  DataStatus["LOADING"] = "LOADING";
  DataStatus["DONE"] = "DONE";
  DataStatus["ERROR"] = "ERROR";
  return DataStatus;
}({});
export const bulkSlotsSize = 4;
//# sourceMappingURL=appointment-state.js.map